import moment from 'moment';

export const filterMixin = {
    methods: {
        filterQueryGenerator(filterListLocal, column, val, type, direction) {
            const filterList = filterListLocal.filter(function (value) {
                return value.key != column;
            });
            if (val != null && column != null) {
                filterList.push({key: column, value: val, type, direction});
            }
            this.filterQuery = '';
            filterList.forEach(element => {
                switch (element.type) {
                    case 'fixedCustomDate':
                        this.filterQuery += '&' + element.key + '[' + element.direction + ']=' + element.value;
                        break;
                    case 'fixedDate': {
                        const new_date = moment(element.value, 'YYYY-MM-DD');
                        const end = moment(new_date).add(1, 'days').format('YYYY-MM-DD');
                        this.filterQuery += `&${element.key}[after]=${element.value}&${element.key}[before]=${end}`;
                        break;
                    }
                    case 'currentDate': {
                        const currentDate = moment().format('YYYY-MM-DD');
                        this.filterQuery += '&' + element.key + '[' + element.value + ']=' + currentDate;
                        break;
                    }
                    default:
                        this.filterQuery += '&' + element.key + '=' + element.value;
                }
            });
            return filterList;
        },
        orderQueryGenerator(column, orderOrientation) {
            const sortType = orderOrientation ? 'desc' : 'asc';
            this.sort = `&order[${column}]=${sortType}`;
        }
    }
};
